import React, { useState } from 'react';
import './Tokenization.css';
import Footer from '../unAuth/Components/footer';


function Tokenization({ onLearnMore }) {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: 'Is this crypto?',
      answer: 'No. Tokens record ownership in a regulated fund that holds real assets; your rights come from the subscription docs.'
    },
    {
      question: 'Are returns/taxes different?',
      answer: 'No change to economics or tax character based purely on tokenization. Consult your tax advisor.'
    },
    {
      question: 'Is liquidity guaranteed?',
      answer: 'No. Secondary availability depends on venue approvals and buyer demand.'
    },
    {
      question: 'Do I need a wallet?',
      answer: 'Yes, a supported wallet for whitelisting, funding (where permitted), and receiving distributions.'
    }
  ];

  return (
    <div className="tokenization-page-wrapper">
      <div className="tokenization-page container">
        
        {/* HERO SECTION */}
        <section className="tokenization-hero-section" aria-labelledby="hero-title">
          <div className="tokenization-hero-content">
            <h1 id="hero-title" className="tokenization-hero-title">
              Tokenized Ownership: Same Rights, Modern Rails
            </h1>
            <p className="tokenization-hero-subtitle">
              Your interest is the same regulated ownership — now recorded on-chain for clear records and optional transfers
            </p>
          </div>
        </section>

        {/* VALUE GRID SECTION */}
        <section className="value-grid-section" aria-labelledby="value-grid-title">
          <h2 id="value-grid-title" className="section-title">Why it Matters</h2>
          <div className="value-grid">
            <div className="value-card">
              <h3 className="value-card-title">Transparency</h3>
              <p className="value-card-body">
                On-chain issuance and ownership let approved buyers see provenance, distributions, and outstanding supply without guesswork
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-card-title">Liquidity (optional)</h3>
              <p className="value-card-body">
                Approved secondary venues enable wallet-to-wallet transfers; manager pays the current holder. Liquidity is not guaranteed
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-card-title">Accessibility</h3>
              <p className="value-card-body">
                Digital onboarding, KYC/whitelisting, and (where permitted) USDC funding shorten the path from diligence to allocation
              </p>
            </div>
            <div className="value-card">
              <h3 className="value-card-title">Tangibility</h3>
              <p className="value-card-body">
                Tokens represent ownership in a fund that holds real commercial assets with national-credit tenants — not a meme coin
              </p>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS SECTION */}
        <section className="how-it-works-section" aria-labelledby="how-it-works-title">
          <h2 id="how-it-works-title" className="section-title">How It Works</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">Verify</h3>
                <p className="step-description">Complete KYC and get your wallet whitelisted</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">Subscribe</h3>
                <p className="step-description">Review offering docs and fund with USD or USDC (where permitted)</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">Receive Tokens</h3>
                <p className="step-description">Your tokens represent ownership in the fund</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3 className="step-title">Distributions</h3>
                <p className="step-description">Cash flows route to the wallet that holds the tokens</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3 className="step-title">Optional Transfer</h3>
                <p className="step-description">If you sell on an approved venue, transfer settles wallet-to-wallet; no re-papering for the manager</p>
              </div>
            </div>
          </div>
        </section>

        {/* LEARN MORE CTA SECTION */}
        <section className="learn-more-cta-section">
          <div className="learn-more-container">
            <button className="learn-more-button" onClick={onLearnMore}>
              Learn More
            </button>
          </div>
        </section>

        {/* AUDIENCE CALLOUTS SECTION */}
        <section className="audience-callouts-section" aria-labelledby="audience-callouts-title">
          <h2 id="audience-callouts-title" className="section-title">For Different Investors</h2>
          <div className="audience-callouts">
            <div className="audience-card">
              <h3 className="audience-card-title">For CRE Investors</h3>
              <p className="audience-card-body">
                Same LLC rights and regs, now with clearer records and an option for secondary transfer instead of redemption windows
              </p>
            </div>
            <div className="audience-card">
              <h3 className="audience-card-title">For Crypto-Native Investors</h3>
              <p className="audience-card-body">
                A durable, income-oriented allocation in single-tenant CRE — with on-chain records and digital funding rails              </p>
            </div>
          </div>
        </section>

        {/* FAQ SECTION */}
        <section className="faq-section" aria-labelledby="faq-title">
          <h2 id="faq-title" className="section-title">Frequently Asked Questions</h2>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button
                  className={`faq-question ${openFaq === index ? 'open' : ''}`}
                  onClick={() => toggleFaq(index)}
                  aria-expanded={openFaq === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  {faq.question}
                  <span className="faq-icon">{openFaq === index ? '−' : '+'}</span>
                </button>
                <div
                  id={`faq-answer-${index}`}
                  className={`faq-answer ${openFaq === index ? 'open' : ''}`}
                  aria-hidden={openFaq !== index}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* COMPLIANCE NOTE */}
        <section className="compliance-section" aria-labelledby="compliance-title">
          <div className="compliance-note">
            <p>
              Tokenization does not change investor rights or regulations. Distributions and liquidity, if any, are not guaranteed
            </p>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="cta-section" aria-labelledby="cta-title">
          <div className="cta-buttons">
            <button onClick={onLearnMore} className="cta-button primary">Learn More</button>
          </div>
        </section>

      </div>
      <Footer />
    </div>
  );
}

export default Tokenization;
